// v2/constants/catalog.js — grup / kategori / depo sabitleri

// Cariye ozel zincir indirimler. Gercek veride API'den gelecek.
export const DISCOUNT_CHAINS = {
  A: [20, 5, 4],
  B: [18, 4],
  C: [15, 3],
  D: [12, 2],
  E: [10, 2],
};

// Aktif kampanyalar — kategori bazli EK indirim (zincirin sonuna eklenir).
// Gercek veride API'den kampanya dizisi gelecek.
export const CAMPAIGNS = {
  'Filtreler': { rate: 8, label: 'Filtre Kampanyası' },
  'Fren Sistemi': { rate: 5, label: 'Fren Kampanyası' },
};

export const GROUP_LABELS = {
  A: 'Grup A', B: 'Grup B', C: 'Grup C', D: 'Grup D', E: 'Grup E',
};

export const CATEGORIES = [
  'Motor Parçaları',
  'Elektrik & Elektronik',
  'Fren Sistemi',
  'Süspansiyon',
  'Filtreler',
  'Diğer',
];

export const WAREHOUSES = [
  { key: 'gaziantepStock', label: 'Gaziantep Depo', short: 'GZT', city: 'Gaziantep', from: "Gaziantep'ten" },
  { key: 'istanbulStock',  label: 'İstanbul Depo',  short: 'İST', city: 'İstanbul',  from: "İstanbul'dan" },
];

export const DELIVERY_TIME = '1-2 iş günü';

export const ACCOUNT_MENU = [
  { id: 'profile',   label: 'Profilim' },
  { id: 'statement', label: 'Hesap Ekstresi' },
  { id: 'orders',    label: 'Siparişlerim' },
  { id: 'favorites', label: 'Favorilerim' },
  { id: 'settings',  label: 'Ayarlar' },
  { id: 'logout',    label: 'Çıkış Yap', danger: true },
];
